import { domain, storefrontAccessToken } from '../reducers/cart'
import request from 'superagent'

export const graphqlQuery = query =>
  request
    .post(`https://${domain}/api/graphql`)
    .set('X-Shopify-Storefront-Access-Token', storefrontAccessToken)
    .set('Content-Type', 'application/graphql')
    .send(query)
